export default __webpack_public_path__ + "static/media/SWT0340.34I-20350_-14783_0.0ee994b2.jpg";